import React, { useEffect, useRef, useContext as useReactContext } from "react";
import { TimerDisplay } from "../context/TimerDisplay";
import { TimerProvider, useTimer } from "../context/TimerContext";
import { SocketContext } from "../context/SocketProvider";
import { useLoading } from "../context/LoadingContext";
import { DEFAULT_ROOM } from "../constants/gameStages";

const LayoutBody = ({ onTimeout, children }) => {
  const { timeRemaining } = useTimer();

  useEffect(() => {
    if (timeRemaining <= 0) {
      onTimeout?.();
    }
  }, [timeRemaining, onTimeout]);

  return (
    <div className="flex w-full items-center justify-center bg-transparent">
      <div className="fixed top-0 left-1/2 transform -translate-x-1/2" style={{ zIndex: 15 }}>
        <TimerDisplay />
      </div>

      <div className="w-full">{children}</div>
    </div>
  );
};

const TimerLayout = ({
  onTimeout,
  duration = 120,
  shouldStartTimer = true,
  children,
}) => {
  const { socket } = useReactContext(SocketContext);
  const { loading } = useLoading();
  const prevLoading = useRef(loading);

  useEffect(() => {
    // Only emit start_timer when loading transitions from true to false
    if (shouldStartTimer && prevLoading.current && !loading) {
      socket.emit("start_timer", { room: DEFAULT_ROOM, duration });
    }
    prevLoading.current = loading;
  }, [socket, duration, shouldStartTimer, loading]);

  return (
    <TimerProvider duration={duration}>
      <LayoutBody onTimeout={onTimeout}>{children}</LayoutBody>
    </TimerProvider>
  );
};

export default TimerLayout;
